
import { granjaApi } from "../../api";
import { usePlanillassStore } from "../../store";

import Swal from "sweetalert2";





export const startPlanillaXID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/planilla/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}




export const startPlanillaXIDEditar = async(id) => {
    try {
        const { data } = await granjaApi.get(`/planilla/xid/${id}`);
        const { data:cargueros } = await granjaApi.get(`/carguero/xplanilla/${id}`);
        const dts = data.data;
        const datosCarguero = cargueros.data;

        const newDatos ={
            vehiculo: dts.vehiculo,
            conductor: dts.conductor._id,
            cliente: dts.cliente._id,
            pesador: dts.pesador._id,
            horaInicio: dts.horaInicio,
            horaFinal: dts.horaFinal,
            descuento: dts.descuento,
            cantidad: dts.cantidad,
            valorKilo: dts.valorKilo,
            fecha: dts.fecha,
            cargueros: [ ...datosCarguero.map( item => item.usuario._id) ],
            acuerdo: dts.acuerdo,
            valorAcordado: dts.valorAcordado,
            observacion: dts.observacion,
        }
        usePlanillassStore.setState({ formValues: newDatos, items: dts.items });
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}





export const startPlanillasXLoteDistri = async({ page=0, id, termino }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('id',  id);
        params.append('termino',  termino);
        const { data } = await granjaApi.get(`/planilla/xlotedistri`, { params });
        
        usePlanillassStore.setState({ totalPlanillas: data.total, datosPlanilla: data.datos  });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}






export const startSavingPlanilla = async(planilla) => {
    try {
        await granjaApi.post('/planilla/new', planilla);
        Swal.fire('Exitoso', 'Planilla Creada', 'success');
        return true;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        return false;
    }
} 





export const startEditarPlanilla = async(planilla) => {
    try {
        await granjaApi.put(`/planilla/${planilla.id}`, planilla);
        Swal.fire('Exitoso', 'Planilla Editada', 'success');
        return true;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
} 





export const startEliminarPlanilla = async(id) => {
    try {
        await granjaApi.delete(`/planilla/${id}`);
        Swal.fire('Exitoso', 'Planilla Eliminada', 'success');
        return true;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
} 


